export const firebaseConfig = {
  apiKey: 'AIzaSyDLejcXq2tpapC9Gk93O1aUv18LIM1xKRY',
  authDomain: 'acre-453d2.firebaseapp.com',
  projectId: 'acre-453d2',
  storageBucket: 'acre-453d2.appspot.com',
  messagingSenderId: '10333093507',
  appId: '1:10333093507:web:d064431ee65c3d2c0e25b6',
  measurementId: 'G-HCT2J4GZQN',
};
